import { SxProps, Theme } from '@mui/material';

const divider: SxProps<Theme> = {
  marginBottom: 3,
};

const styles = {
  divider,
};

export default styles;
